<template>
    <modal @close="closeAddUser" class="edit-modal" id="add-user" hideFooter>
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name mb-2 mt-4">
                    <h3>Add User</h3>

                    <p>You can use this form to add a new user to <strong class="td-text-primary">{{accountSummary.n}}.</strong>  The user account will be created immediately, no email is sent the user and no verification of email address/mobile is required.</p>
                    <p>
                        The minimum required fields are:
                    </p>
                    <ul>
                        <li>First Name</li>
                        <li>Last Name</li>
                        <li>Email Address</li>
                    </ul>
                    <p>
                    The remaining fields are optional/have default values.
                    </p>
                    <p>Remember to assign appropriate settings and preferences to control their access levels within the website.</p>

                </div>
            </div>
            <div class="edit-pages">
                <div class="form-page active td-form wide-form">
                    <div class="td-banner danger my-2 dismissible" v-if="errorMessage">
                        <icon name="faTriangleExclamation" type="solid"></icon>
                        <p>{{errorMessage}}</p>
                        <icon type="solid" name="faXmark" aria-hidden="true" @click="errorMessage = ''"></icon>
                    </div>
                    <div class="md-col-3">
                        <div class="inputs">
                            <div class="my-2">
                                <h2 class="td-label">User Info</h2>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">First Name:</label>
                                <input v-model="addUserModel.firstName" type="text" placeholder="" :class="{'error': userValidator.errors['firstName']}"
                                       @input="userValidator.validate('firstName')" />
                                <error v-if="userValidator.errors['firstName']" :error="userValidator.errors['firstName']"></error>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">Last Name:</label>
                                <input v-model="addUserModel.lastName" type="text" placeholder="" :class="{'error': userValidator.errors['lastName']}"
                                       @input="userValidator.validate('lastName')" />
                                <error v-if="userValidator.errors['lastName']" :error="userValidator.errors['lastName']"></error>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">Email:</label>
                                <input v-model="addUserModel.email" type="text" placeholder="" :class="{'error': userValidator.errors['email']}"
                                       @input="userValidator.validate('email')" />
                                <error v-if="userValidator.errors['email']" :error="userValidator.errors['email']"></error>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">Mobile:</label>
                                <input v-model="addUserModel.mobile" type="text" placeholder="" :class="{'error': userValidator.errors['mobile']}"
                                       @input="userValidator.validate('mobile')" />
                                <error v-if="userValidator.errors['mobile']" :error="userValidator.errors['mobile']"></error>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">Office:</label>
                                <input v-model="addUserModel.office" type="text" placeholder="" :class="{'error': userValidator.errors['office']}"
                                       @input="userValidator.validate('office')" />
                                <error v-if="userValidator.errors['office']" :error="userValidator.errors['office']"></error>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">Home:</label>
                                <input v-model="addUserModel.home" type="text" placeholder="" :class="{'error': userValidator.errors['home']}" />
                                <error v-if="userValidator.errors['home']" :error="userValidator.errors['home']"></error>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">Fax:</label>
                                <input v-model="addUserModel.fax" type="text" placeholder="" :class="{'error': userValidator.errors['fax']}"
                                       @input="userValidator.validate('fax')" />
                                <error v-if="userValidator.errors['fax']" :error="userValidator.errors['fax']"></error>
                            </div>
                        </div>
                        <div class="inputs">
                            <div class="my-2">
                                <h2 class="td-label">User Security Settings:</h2>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold">
                                    Primary Contact
                                    <input name="primaryContact" type="checkbox" v-model="addUserModel.isPrimary" :checked="addUserModel.isPrimary === true" :disabled="addUserModel.isPrimary === true" />
                                    <span></span>
                                </label>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold">
                                    Billing Contact
                                    <input name="billingContact" type="checkbox" v-model="addUserModel.isBilling" :checked="addUserModel.isBilling === true" />
                                    <span></span>
                                </label>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold">
                                    Allowed to Rate Vendors
                                    <input name="allowedToRateVendors" type="checkbox" v-model="addUserModel.suppressRatings" :checked="addUserModel.suppressRatings === false" />
                                    <span></span>
                                </label>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold">
                                    Account Administrator
                                    <input name="isAdmin" type="checkbox" v-model="addUserModel.isAdmin" :checked="addUserModel.isAdmin" />
                                    <span></span>
                                </label>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold">
                                    Allow Ratings
                                    <input name="allowRatings" type="checkbox" v-model="addUserModel.allowRatings" :checked="addUserModel.allowRatings === true" />
                                    <span></span>
                                </label>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold">
                                    Edit Notes
                                    <input name="editNotes" type="checkbox" v-model="addUserModel.editNotes" :checked="addUserModel.editNotes === true" />
                                    <span></span>
                                </label>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold">
                                    Manage Service Network
                                    <input name="addFavoriteAvoid" type="checkbox" v-model="addUserModel.addFavoriteAvoid" :checked="addUserModel.addFavoriteAvoid" />
                                    <span></span>
                                </label>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold">
                                    Advanced Preferences
                                    <input name="advancedPreferences" type="checkbox" v-model="addUserModel.advancedPreferences" :checked="addUserModel.advancedPreferences" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Username:</label>
                                <input v-model="addUserModel.username" type="text" placeholder="" :class="{'error': userValidator.errors['username']}"
                                       @input="userValidator.validate('username')" />
                                <error v-if="userValidator.errors['username']" :error="userValidator.errors['username']"></error>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">Password:</label>
                                <input v-model="passwordForm.newPassword" type="password" placeholder="" :class="{'error': passwordValidator.errors['newPassword']}"
                                       @input="passwordValidator.validate('newPassword')" />
                                <error v-if="passwordValidator.errors['newPassword']" :error="passwordValidator.errors['newPassword']"></error>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">Confirm Password:</label>
                                <input v-model="passwordForm.confirmPassword" type="password" placeholder="" :class="{'error': passwordValidator.errors['confirmPassword']}"
                                       @input="passwordValidator.validate('confirmPassword')" />
                                <error v-if="passwordValidator.errors['confirmPassword']" :error="passwordValidator.errors['confirmPassword']"></error>
                            </div>

                        </div>
                        <div class="inputs">
                            <div class="my-2">
                                <h2 class="td-label">User Preferences:</h2>
                            </div>

                            <div>
                                <div class="td-autocomplete form-item">
                                    <timezone-lookup @select-timezone="selectTimeZone"
                                                     :selected-time-zone="addUserModel.timeZone"
                                                     :time-zones="timeZones">
                                    </timezone-lookup>
                                </div>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">Unit of Measure:</label>
                                <select v-model="addUserModel.measureUnit" required :class="{'error': userValidator.errors['measureUnit']}" @change="userValidator.validate('measureUnit')">
                                    <option :value="MeasureUnit.Imperial"> {{measureUnitDisplay(MeasureUnit.Imperial)}} </option>
                                    <option :value="MeasureUnit.Metric"> {{measureUnitDisplay(MeasureUnit.Metric)}} </option>
                                </select>
                                <error v-if="userValidator.errors['measureUnit']" :error="userValidator.errors['measureUnit']"></error>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">Default Search Services:</label>
                                <div class="service td-autocomplete">
                                    <div class="autocomplete-input">
                                        <div class="td-selected-input" name="service" v-for="service in addUserModel.defaultServices">
                                            <span>
                                                {{ serviceDisplay(service) }}
                                                <a class="service-close" href="#" @click.prevent="deselectService(service)">
                                                    <icon type="solid" name="faXmark" aria-hidden="true"></icon>
                                                </a>
                                            </span>
                                        </div>
                                        <input id="default-services-input" type="text" placeholder="Type service name and select to add" name="services" v-model="searchTermService" />
                                    </div>
                                    <div :class="[searchTermService && searchTermService != '' ? 'show-results' : 'hide-results', 'autocomplete-results']">
                                        <ul class="results-list">
                                            <li v-for="service in getNotSelectedServices()">
                                                <a @click.prevent="selectService(service.code)" href="#">{{service.name}}</a>
                                            </li>
                                        </ul>
                                        <icon @click="searchTermService = ''" name="faXmark" type="solid" class="td-text-danger close-list"></icon>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold mt-0">
                                    Receive Newsletter
                                    <input v-model="addUserModel.receiveProductUpdates" name="receiveProductUpdates" type="checkbox" />
                                    <span></span>
                                </label>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold mt-0">
                                    Receive Reports
                                    <input v-model="addUserModel.receiveReports" name="receiveReports" type="checkbox" />
                                    <span></span>
                                </label>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold mt-0">
                                    Hide Managed Services
                                    <input v-model="addUserModel.hideManagedServices" name="hideManagedServices" type="checkbox" />
                                    <span></span>
                                </label>
                            </div>

                            <div>
                                <label class="td-checkbox-label td-text-bold mt-0">
                                    Search By Distance
                                    <input v-model="addUserModel.searchByDistance" name="searchByDistance" type="checkbox" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-2">
                                <label class="td-label td-text-bold mt-0">Search Private Radius:</label>
                                <select v-model="addUserModel.searchPrivateRadius" required :class="{'error': userValidator.errors['searchPrivateRadius']}" @change="userValidator.validate('searchPrivateRadius')">
                                    <option :value="SearchRadiusPreference.Zero"> {{searchDistanceDisplay(SearchRadiusPreference.Zero)}} </option>
                                    <option :value="SearchRadiusPreference.five"> {{searchDistanceDisplay(SearchRadiusPreference.five)}} </option>
                                    <option :value="SearchRadiusPreference.ten"> {{searchDistanceDisplay(SearchRadiusPreference.ten)}} </option>
                                    <option :value="SearchRadiusPreference.fifteen"> {{searchDistanceDisplay(SearchRadiusPreference.fifteen)}} </option>
                                    <option :value="SearchRadiusPreference.twenty"> {{searchDistanceDisplay(SearchRadiusPreference.twenty)}} </option>
                                    <option :value="SearchRadiusPreference.twentyFive"> {{searchDistanceDisplay(SearchRadiusPreference.twentyFive)}} </option>
                                    <option :value="SearchRadiusPreference.fifty"> {{searchDistanceDisplay(SearchRadiusPreference.fifty)}} </option>
                                    <option :value="SearchRadiusPreference.hundred"> {{searchDistanceDisplay(SearchRadiusPreference.hundred)}} </option>
                                </select>
                                <error v-if="userValidator.errors['searchPrivateRadius']" :error="userValidator.errors['searchPrivateRadius']"></error>
                            </div>

                            <div>
                                <label class="td-label td-text-bold mt-0">Search Preferred Radius:</label>
                                <select v-model="addUserModel.searchPreferredRadius" required :class="{'error': userValidator.errors['searchPreferredRadius']}" @change="userValidator.validate('searchPreferredRadius')">
                                    <option :value="SearchRadiusPreference.Zero"> {{ searchDistanceDisplay(SearchRadiusPreference.Zero) }} </option>
                                    <option :value="SearchRadiusPreference.five"> {{ searchDistanceDisplay(SearchRadiusPreference.five) }} </option>
                                    <option :value="SearchRadiusPreference.ten"> {{ searchDistanceDisplay(SearchRadiusPreference.ten) }} </option>
                                    <option :value="SearchRadiusPreference.fifteen"> {{ searchDistanceDisplay(SearchRadiusPreference.fifteen) }} </option>
                                    <option :value="SearchRadiusPreference.twenty"> {{ searchDistanceDisplay(SearchRadiusPreference.twenty) }} </option>
                                    <option :value="SearchRadiusPreference.twentyFive"> {{ searchDistanceDisplay(SearchRadiusPreference.twentyFive) }} </option>
                                    <option :value="SearchRadiusPreference.fifty"> {{ searchDistanceDisplay(SearchRadiusPreference.fifty) }} </option>
                                    <option :value="SearchRadiusPreference.hundred"> {{ searchDistanceDisplay(SearchRadiusPreference.hundred) }} </option>
                                </select>
                                <error v-if="userValidator.errors['searchPreferredRadius']" :error="userValidator.errors['searchPreferredRadius']"></error>
                            </div>

                            <div>
                                <h5 class="td-h5 mt-3">Fleet Service Request Rights:</h5>
                                <div>
                                    <select v-model="addUserModel.selectedFleetServiceRequestsRight" class="td-select">
                                        <option value="" selected> None </option>
                                        <option v-for="(key, label) in fleetServiceRequestRights" :key="key" :value="key">{{ label }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="accountType == 1">
                                <h5 class="td-h5 mt-3">Vendor Service Request Rights:</h5>
                                <div>
                                    <select v-model="addUserModel.selectedVendorServiceRequestsRight" class="td-select">
                                        <option value="" selected> None </option>
                                        <option v-for="(key, label) in vendorServiceRequestRights" :key="key" :value="key">{{ label }}</option>
                                    </select>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="actions">
                    <div>
                        <button class="td-btn btn primary-outlined" title="Close Add User" @click="closeAddUser">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="secondary td-btn" title="Add User" @click="addUserSubmit">Add User</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>import script from './AddUserAdmin';
    export default script;</script>

<style lang="less">
    @import "./AddUserAdmin.less";
</style>


